@for (message of messages$ | async; track message.notificationId) {
  <article
    class="notification"
    [attr.data-severity]="message.severity || 'info'"
    [attr.role]="
      message.severity === 'error' || message.severity === 'warn'
        ? 'alert'
        : 'status'
    "
    aria-atomic="true"
  >
    <div class="message">
      @if (message.summary) {
        <strong>{{ message.summary }}</strong>
      }
      @if (message.detail) {
        <p>{{ message.detail }}</p>
      }
    </div>
    @if (message.closable !== false) {
      <button
        mat-icon-button
        type="button"
        aria-label="Zamknij powiadomienie"
        (click)="notifications.dismiss(message.notificationId)"
      >
        <span aria-hidden="true">×</span>
      </button>
    }
  </article>
}
